const OUTPATIENT_ACTION_TYPES = {
  OUTPATIENT_DETAILS: 'OUTPATIENT_DETAILS',
  OUTPATIENT_FILTER_SEARCH: 'OUTPATIENT_FILTER_SEARCH',
  FRONTDESK_ACTION: 'FRONTDESK_ACTION',
  FRONTDESK_DATA: 'FRONTDESK_DATA',
};

export default OUTPATIENT_ACTION_TYPES;
